(function() {
  const originalFetch = window.fetch;
  let gpoItemsAdded = false;

  window.fetch = async function(url, options) {
    const urlStr = typeof url === 'string' ? url : url.toString();

    // Only intercept cart/add requests
    if (urlStr.includes('/cart/add') && !gpoItemsAdded) {
      // Collect GPO add-on variant IDs
      const gpoApp = document.querySelector('.gpo-app');
      if (gpoApp) {
        const gpoVariantIds = [];
        gpoApp.querySelectorAll('input[type="checkbox"][gpo-data-variant-id]:checked').forEach(function(input) {
          const variantId = input.getAttribute('gpo-data-variant-id');
          if (variantId) gpoVariantIds.push(variantId);
        });

        // If there are GPO items, add them first
        if (gpoVariantIds.length > 0) {
          gpoItemsAdded = true;
          const gpoItems = gpoVariantIds.map(function(id) { return { id: Number(id), quantity: 1 }; });
          try {
            await originalFetch.call(window, '/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: gpoItems })
            });
          } catch(e) {}
          // Reset flag after a delay to allow for next add-to-cart
          setTimeout(function() { gpoItemsAdded = false; }, 1000);
        }
      }
    }

    return originalFetch.apply(window, arguments);
  };
})();
